import { createRouter, createWebHistory, type LocationQuery } from 'vue-router'
import routes from './routes'
import addGuardsToRouter from './guards'
import qs from 'qs'

const router = createRouter({
    history: createWebHistory(import.meta.env.VITE_BASE_URL ?? import.meta.env.BASE_URL),
    routes,
    scrollBehavior: (from, to) => {
        if (to.hash) {
            return undefined 
        }
        return { top: 0, behavior: 'smooth' }
    },
    parseQuery: (search: string) => {
        return qs.parse(search) as LocationQuery
    },
    stringifyQuery: (query: Record<string, ANY>) => {
        const filteredQuery = Object.fromEntries(
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            Object.entries(query).filter(([_, value]) => value !== '' && value !== null && value !== undefined),
        )
        return qs.stringify(filteredQuery, { skipNulls: true })
    },
})

addGuardsToRouter(router)

export default router
